import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LabResult } from '../../services/lab-results-service/types';
import { useLabResultsStore } from '../../store/lab-results-store';

interface ItemProps {
  labResult: LabResult
}

const LabResultItem: React.FC<ItemProps> = ({ labResult }: ItemProps) => {
  const setCurrentLabResult = useLabResultsStore((state) => state.setCurrentLabResult);
  const navigate = useNavigate();

  const redirect = useCallback(() => {
    setCurrentLabResult(labResult);
    navigate(`/lab-results/${labResult.id}`);
  }, [setCurrentLabResult, labResult, navigate]);

  return (
    <button
      type="button"
      onClick={() => redirect()}
      className="w-full text-left px-8 py-2 shadow-lg text-blue hover:text-darkblue"
    >
      {labResult.accession}
      {' '}
      |
      {' '}
      {labResult.firstName}
      {' '}
      {labResult.lastName}
    </button>
  );
};

export const LabResultList: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState<boolean>(false);
  const listLabResults = useLabResultsStore((state) => state.listLabResults);
  const results = useLabResultsStore((state) => state.results);

  const switchPage = useCallback(async (page: number) => {
    if (page > 1) {
      setSearchParams({ page: page.toString() });
    }
    setLoading(true);
    await listLabResults(page);
    setLoading(false);
  }, [setSearchParams, listLabResults]);

  useEffect(() => {
    const page = searchParams.get('page');
    switchPage(Number(page) || 1);
  }, [searchParams, switchPage]);

  return (
    <div>
      {loading ? <p>Loading...</p> : results.map((labResult) => (
        <div>
          <LabResultItem key={`key-${labResult.id}`} labResult={labResult} />
        </div>
      ))}
      {/* TODO: Page buttons when backend already supports it */}
    </div>
  );
};
